import {useEffect} from "react";
import {useParams, useHistory} from "react-router-dom";
import swal from 'sweetalert';
import Swal from 'sweetalert2';
import {actionHandelRemoveAllItemInBasketCart} from "../../../../../redux/actions/modals/modalShoppingCard";
import {useDispatch} from "react-redux";
import {actionRefreshModalAddDiscountCode} from "../../../../../redux/actions/modals/modalAddDiscountCode";
import {PUBLIC_URL_SERVER} from "../../../../../apis";

const PayResult = () => {
    const {origin, status} = useParams();
    let history = useHistory();
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(actionRefreshModalAddDiscountCode());
        history.push("/");
        switch (origin) {
            case 'charge-wallet':
                chargeWallet();
                break;
            case 'online-payment':
                onLinePayment();
                break;
            default:
        }

    });

    const btnOkSingle = Swal.mixin({
        customClass: {
            confirmButton: 'base-btn-green-border btn btn-success',
        },
        buttonsStyling: false
    });

    const onLinePayment = () => {
        if (status === 'ok') {
            dispatch(actionHandelRemoveAllItemInBasketCart());
            btnOkSingle.fire({
                title: 'پرداخت موفق',
                text: 'پرداخت سفارش با موفقیت انجام شد.',
                imageUrl: PUBLIC_URL_SERVER + '/icons/fm_logo_ofoghi_new.png',
                imageHeight: 45,
                imageAlt: 'فروت مروت',
                confirmButtonText: "تایید",
            });
            if(localStorage.getItem("editOrderMode") !== undefined && localStorage.getItem("editOrderMode") !== null) // az safheye virayeshe sefaresh oomadim
                localStorage.removeItem("editOrderMode");
        } else {
            falsePayment();
        }
    };
    const chargeWallet = () => {
        if (status === 'ok') {
            btnOkSingle.fire({
                title: 'پرداخت موفق',
                text: 'شارژ کیف پول با موفیت انجام شد.',
                imageUrl: PUBLIC_URL_SERVER + '/icons/fm_logo_ofoghi_new.png',
                imageHeight: 45,
                imageAlt: 'فروت مروت',
                confirmButtonText: "تایید",
            });
        } else {
            falsePayment();
        }
    };

    const falsePayment = () => {
        swal({
            title: 'پرداخت ناموفق',
            text: 'متاسفانه پرداخت شما موفقیت آمیز نبود.',
            buttons: {
                cancel: "تایید",
            },
            icon: "error",
        });
    };
    return null;
};

export default PayResult;
